<script setup lang="ts">
import { ref, watch, computed, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useMemberService } from "@/stores/memberFunction/memberService";

import triangle_icon from "@image/memberFunction/common/triangle_icon.png";
import 文字框_長_A from "@image/memberFunction/文字框/文字框_長_A.png";
import seveneleven_logo from "@image/memberFunction/12/7eleven-logo.png";
import family_Logo from "@image/memberFunction/12/family-Logo.png";
import HiLife_Logo from "@image/memberFunction/12/HiLife-Logo.png";
import OK_Logo from "@image/memberFunction/12/OK-Logo.png";
import phone_code from "@image/memberFunction/07/phone_code.png";
import { useLogin } from "@/stores/login";

interface AddStoreDepositFormData {
  sProtocol: string;
  sUsdtAddr: string;
  nVscode: string;
}

const AddStoreForm = ref<any>(null);
// const storeName = ref<string[]>(["TRC-20", "ERC-20"]);
const storeName = ref<string[]>(["TRC-20"]);
const emit = defineEmits(["changeDepositPage"]);
const login = useLogin();
const memberService = useMemberService();
const { isSendMsg } = storeToRefs(memberService);

function changeDepositPage(page: number) {
  emit("changeDepositPage", page);
}
function submit(VForm: AddStoreDepositFormData) {
  AddStoreForm.value.resetForm();
  memberService.getAddMemberUSDT(VForm);
  changeDepositPage(8);
}

const phoneNumber = ref<string>("");
const sendPhoneMsgError = ref<string>("");
async function Phonebtn() {
  sendPhoneMsgError.value = '';
  try {
    const res = await memberService.USDTGetPhoneMailCheck();
    if (res && res.type !== "0") {
      sendPhoneMsgError.value = res.msg;
      return;
    }
  } catch (error) {
    console.error("Error sending phone verification:", error);
  }
}

onMounted(() => {
  if (login.memberData.user_phone) {
    phoneNumber.value = login.memberData.user_phone;
  } else {
    phoneNumber.value = "";
  }
})

</script>
<template>
  <p class="text-[18px] font-bold text-center">
    {{ $t("MemberFunction.Deposit.BindUSDTWallet") }}
  </p>
  <VForm @submit="submit" ref="AddStoreForm" class="px-[9vw]">
    <div class="text-primary">
      <label for="sProtocol" class="grid grid-cols-12 text-[14px] md:text-[16px] mt-[16px] md:mt-[3dvh]">
        <p class="mr-[1em] col-span-4">
          {{ $t("MemberFunction.Deposit.WalletCategory") }}
        </p>
        <div class="relative col-span-8">
          <div class="h-[26px] w-full">
            <img v-img-src="triangle_icon" alt=""
              class="h-[12px] absolute right-[2.5%] md:right-[3.4%] top-[16%] z-20" />
          </div>
          <VField id="sProtocol" :label="$t('MemberFunction.Deposit.PaymentMethod')" name="sProtocol" v-slot="{ field }"
            class="relative" :rules="{ required: true }">
            <select v-bind="field"
              class="absolute select-bg-border top-0 bg-transparent px-2 rounded w-full h-[26px] text-primary">
              <option class="text-black" value="">
                {{ $t("MemberFunction.Deposit.WalletCategoryPlaceholder") }}
              </option>
              <option class="text-black" v-for="value in storeName" :key="value + 'onlineDepositOther'" :value="value">
                {{ value }}
              </option>
            </select>
          </VField>
          <ErrorMessage name="sProtocol" class="text-primary text-[10px]" v-slot="{ message }">
            <p class="text-primary text-[10px] mr-[6px]">
              {{
                message.includes("必填")
                  ? $t("MemberFunction.Deposit.Require")
                  : message
              }}
            </p>
          </ErrorMessage>
        </div>
      </label>
      <label for="sUsdtAddr" class="grid grid-cols-12 text-[14px] md:text-[16px] mt-[16px] md:mt-[3dvh]">
        <p class="mr-[1em] col-span-4">
          {{ $t("MemberFunction.Deposit.WalletAddress") }}
        </p>
        <div class="relative inline-block col-span-8">
          <div class="h-[26px]">
            <img v-img-src="文字框_長_A" alt="" class="h-[26px] w-full" />
          </div>
          <VField class="col-span-1 absolute h-[26px] top-0 rounded-md bg-transparent w-full px-2" id="sUsdtAddr"
            :label="$t('MemberFunction.Deposit.DepositAmount')" name="sUsdtAddr" type="string"
            :rules="{ required: true }" />
          <ErrorMessage name="sUsdtAddr" class="text-primary text-[10px]" v-slot="{ message }">
            <p class="text-primary text-[10px] mr-[6px]">
              {{
                message.includes("必填")
                  ? $t("MemberFunction.Deposit.Require")
                  : message
              }}
            </p>
          </ErrorMessage>
        </div>
      </label>
      <label for="sPhone" class="grid grid-cols-12 text-[14px] md:text-[16px] mt-[16px] md:mt-[3dvh] relative">
        <p class="mr-[1em] col-span-4">
          {{ $t("MemberFunction.Deposit.PhoneNumber") }}
        </p>
        <div class="relative inline-block col-span-8">
          <div class="relative">
            <div class="h-[26px]">
              <img v-img-src="文字框_長_A" alt="" class="h-[26px] w-full" />
            </div>
            <VField class="col-span-1 absolute h-[26px] top-0 rounded-md bg-transparent w-full px-2" id="sPhone"
              :label="$t('MemberFunction.Deposit.PhoneNumberPlaceholder')" name="sPhone" type="string"
              v-model="phoneNumber" :rules="{ required: true }" disabled="true" />
            <div class="flex justify-center items-center absolute top-1/2 -translate-y-1/2 right-0">
              <button @click="Phonebtn" type="button" :class="{ grayscale: !isSendMsg }" :disabled="!isSendMsg">
                <div class="relative">
                  <img class="w-[70px]" v-img-src="phone_code" alt="" />
                  <p
                    class="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-[12px] w-[100%] leading-[10px] text-black font-bold">
                    {{ $t("LoginView.GetVerification") }}
                  </p>
                </div>
              </button>
            </div>
          </div>

          <p v-if="sendPhoneMsgError !== ''" class="text-primary text-[10px] mr-[6px]">
            {{ sendPhoneMsgError }}
          </p>
        </div>
      </label>
      <label for="nVscode" class="grid grid-cols-12 text-[14px] md:text-[16px] mt-[16px] md:mt-[3dvh]">
        <p class="mr-[1em] col-span-4">
          {{ $t("MemberFunction.Deposit.Verification") }}
        </p>
        <div class="relative inline-block col-span-8">
          <div class="h-[26px]">
            <img v-img-src="文字框_長_A" alt="" class="h-[26px] w-full" />
          </div>
          <VField class="col-span-1 absolute h-[26px] top-0 rounded-md bg-transparent w-full px-2" id="nVscode"
            :label="$t('MemberFunction.Deposit.VerificationPlaceholder')" name="nVscode" type="string"
            :rules="{ required: true }" />
          <ErrorMessage name="nVscode" class="text-primary text-[10px]" v-slot="{ message }">
            <p class="text-primary text-[10px] mr-[6px]">
              {{
                message.includes("必填")
                  ? $t("MemberFunction.Deposit.VerificationPlaceholder")
                  : message
              }}
            </p>
          </ErrorMessage>
        </div>
      </label>
    </div>

    <div class="mt-[3dvh] md:static flex flex-col justify-center items-center">
      <button type="submit" class="btn-y-border">
        <p class="text-[14px] md:text-[14px] font-bold text-secondary px-[2em] py-[.1em]">
          {{ $t("MemberFunction.Deposit.Submit") }}
        </p>
      </button>
      <div class="mt-[3dvh]">
        <div class="flex justify-center items-center leading-[36px]">
          <img src="@image/memberFunction/11/驚嘆號icon.png" alt="" class="w-[16px] mr-1" />
          <span class="text-red-600">
            {{ $t("MemberFunction.Deposit.StoreNotice") }}
          </span>
        </div>
        <div class="text-primary text-[14px] md:text-[16px] leading-[20px]">
          <div class="mb-[1vh] flex">
            <p class="text-red-600 mr-1">※</p>
            <p>
              {{ $t("MemberFunction.Deposit.USDT2NoticeList1") }}
            </p>
          </div>
          <div class="mb-[1vh] flex">
            <p class="text-red-600 mr-1">※</p>
            <p>{{ $t("MemberFunction.Deposit.USDT2NoticeList2") }}</p>
          </div>
          <div class="mb-[1vh] flex">
            <p class="text-red-600 mr-1">※</p>
            <p>
              {{ $t("MemberFunction.Deposit.USDT2NoticeList3") }}
            </p>
          </div>
          <div class="mb-[1vh] flex">
            <p class="text-red-600 mr-1">※</p>
            <p>
              {{ $t("MemberFunction.Deposit.USDT2NoticeList4") }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </VForm>
</template>
